import React from 'react';
import useCallback from '@/util/hook/useCallback';
import useDispatch from '@/util/hook/useDispatch';
import useSelector from '@/util/hook/useSelector';
import { getTubeOptionList } from '../../util/helper/option';
import { careOrderBabyFormUpdate, selectCareOrderBabyForm, } from '../../redux/module/careOrderBabyForm';
import { selectTubeList } from '../../redux/module/remoteConfig';
import View from './View';
import { NO_TUBE_OPTION } from '../../config/option';
import { POPUP_TYPE } from '../../config/popup';
const getIsChoiceChipSelected = ({ tube, optionValue, }) => Boolean(tube && tube.includes(optionValue));
const getIsChoiceChipDisabled = ({ tube, optionValue, }) => Boolean(tube && tube.includes(NO_TUBE_OPTION.title) && optionValue !== NO_TUBE_OPTION.title);
export default function Controller({ popupType, setPopupType }) {
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    const tubeList = useSelector(selectTubeList);
    const dispatch = useDispatch();
    const tubeOptionList = getTubeOptionList({ tubeList });
    const tube = careOrderBabyForm.tube;
    const didCompleteRequiredFormFields = Boolean(tube && tube.length > 0);
    // event handlers
    const handleChoiceChipClick = ({ optionValue, isDisabled, }) => {
        if (isDisabled)
            return;
        const isOptionSelected = tube && tube.includes(optionValue);
        if (isOptionSelected) {
            const tubePayload = tube.filter((item) => item !== optionValue);
            dispatch(careOrderBabyFormUpdate({ tube: tubePayload }));
        }
        else {
            const isNoTubeOption = optionValue === NO_TUBE_OPTION.title;
            const tubePayload = isNoTubeOption ? [optionValue] : [...(tube || []), optionValue];
            dispatch(careOrderBabyFormUpdate({ tube: tubePayload }));
        }
    };
    const handleForwardButtonClick = useCallback(() => {
        setPopupType(POPUP_TYPE.CLOSE);
    }, []);
    return (<View 
    // data
    popupType={popupType} tubeOptionList={tubeOptionList} tube={tube} isForwardButtonAvailable={didCompleteRequiredFormFields} 
    // func
    setPopupType={setPopupType} handleChoiceChipClick={handleChoiceChipClick} handleForwardButtonClick={handleForwardButtonClick} getIsChoiceChipSelected={getIsChoiceChipSelected} getIsChoiceChipDisabled={getIsChoiceChipDisabled}/>);
}
